import { ElapsedTimeMetric } from './elapsedtimemetric';
import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { Named } from '../base/named';
/*
 * Activity Policy.
 */
@Metamodel.model({
    name: 'policy',
    display: [shellStringResources.Pipeline_Policy, shellStringResources.Pipeline_Policies],
    referable: true
})
export class PipelinePolicy extends Named {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        type: ElapsedTimeMetric.MODEL
    })
    public elapsedTimeMetric = Named.create<ElapsedTimeMetric>(ElapsedTimeMetric.MODEL, this);
}
